import { ApiService } from "../../services/api.service";
import { adminPermissionsType, payoutTransactionsType } from "../../types";
import Cookies from "universal-cookie";
import { useEffect, useState, ChangeEvent } from "react";
import { Typography, Pagination, Divider, Tooltip, IconButton } from "@mui/material";
import PageLoading from "../PageLoading/PageLoading";
import JsonView from '@uiw/react-json-view';
import { lightTheme } from '@uiw/react-json-view/light';
import { darkTheme } from '@uiw/react-json-view/dark';
import { useOutletContext } from "../../OutletContext";
import { styled } from "@mui/system";
import Swal from "sweetalert2";

import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomPagination = styled(Pagination)({
    '& .MuiPaginationItem-root': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "rgba(255, 255, 255, .7)", // สีของหน้าที่ไม่ได้เลือก
    },
    '& .Mui-selected': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "white",
    },
});

const bank_data = [
    {
        "bank_code": "002",
        "bank_abbr": "BBL",
        "bank_name_th": "ธนาคารกรุงเทพ",
        "bank_name_en": "Bangkok Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/bbl.png"
    },
    {
        "bank_code": "004",
        "bank_abbr": "KBANK",
        "bank_name_th": "ธนาคารกสิกรไทย",
        "bank_name_en": "Kasikorn Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/kbank.png"
    },
    {
        "bank_code": "006",
        "bank_abbr": "KTB",
        "bank_name_th": "ธนาคารกรุงไทย",
        "bank_name_en": "Thai Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/ktb.png"
    },
    {
        "bank_code": "011",
        "bank_abbr": "TTB",
        "bank_name_th": "ธนาคารทหารไทยธนชาต",
        "bank_name_en": "TMBThanachart Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/ttb.png"
    },
    {
        "bank_code": "014",
        "bank_abbr": "SCB",
        "bank_name_th": "ธนาคารไทยพาณิชย์",
        "bank_name_en": "The Siam Commercial Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/scb.png"
    },
    {
        "bank_code": "025",
        "bank_abbr": "BAY",
        "bank_name_th": "ธนาคารกรุงศรีอยุธยา",
        "bank_name_en": "Bank of Ayudhya Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/bay.png"
    },
    {
        "bank_code": "069",
        "bank_abbr": "KKP",
        "bank_name_th": "ธนาคารเกียรตินาคินภัทร",
        "bank_name_en": "KIATNAKIN PHATRA BANK",
        "bank_logo": "https://cdn.bullpay.me/images/logo/kkp.png"
    },
    {
        "bank_code": "022",
        "bank_abbr": "CIMBT",
        "bank_name_th": "ธนาคารซีไอเอ็มบีไทย",
        "bank_name_en": "CIMB Thai Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/cimb.png"
    },
    {
        "bank_code": "067",
        "bank_abbr": "TISCO",
        "bank_name_th": "ธนาคารทิสโก้",
        "bank_name_en": "TISCO Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/tisco.png"
    },
    {
        "bank_code": "024",
        "bank_abbr": "UOBT",
        "bank_name_th": "ธนาคารยูโอบี",
        "bank_name_en": "United Chinese Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/uob.png"
    },
    {
        "bank_code": "073",
        "bank_abbr": "LHFG",
        "bank_name_th": "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        "bank_name_en": "Land and Houses",
        "bank_logo": "https://cdn.bullpay.me/images/logo/lhbank.png"
    },
    {
        "bank_code": "034",
        "bank_abbr": "BAAC",
        "bank_name_th": "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        "bank_name_en": "Bank for Agriculture and Agricultural Cooperatives",
        "bank_logo": "https://cdn.bullpay.me/images/logo/baac.png"
    },
    {
        "bank_code": "030",
        "bank_abbr": "GSB",
        "bank_name_th": "ธนาคารออมสิน",
        "bank_name_en": "Government Savings Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/gsb.png"
    },
    {
        "bank_code": "033",
        "bank_abbr": "GHB",
        "bank_name_th": "ธนาคารอาคารสงเคราะห์",
        "bank_name_en": "Government Housing Bank",
        "bank_logo": "https://cdn.bullpay.me/images/logo/ghb.png"
    }
];

const formatDate = (date: Dayjs | null) => {
    if (!date) return '';
    return date.format('YYYY-MM-DD');
};

const PayoutTransactions = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [countTransactions, setCountTransactions] = useState<number | null>(null);
    const [transactions, setTransactions] = useState<payoutTransactionsType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);

    const [valueStartDate, setValueStartDate] = useState<Dayjs | null>(dayjs());
    const [valueEndDate, setValueEndDate] = useState<Dayjs | null>(dayjs());

    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getAllTransactions();
    }, [page, limit]);

    const getAllTransactions = async () => {
        if(loading)
        {
            return;
        }

        setLoading(true);
        try {
            const service = new ApiService();
            const getTransactions = await service.getPayoutTransactions(cookies.get('access_token'), formatDate(valueStartDate), formatDate(valueEndDate), page, limit);
            if(getTransactions.data.status_code !== 200)
            {
                return;
            }
            setCountTransactions(getTransactions.data.all_transactions_count);
            setTransactions(getTransactions.data.transactions);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const handleChangePage = (_e: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const copyToClipboard = (value: string) => {
        navigator.clipboard.writeText(value);
    }

    const toggleShow = (index: number) => {
        const id_element = `row-infomation-${index}`;
        const element = document.getElementById(id_element) as HTMLElement;
        if(element)
        {
            const currentDispaly = element.style.display;
            if(currentDispaly === 'none')
            {
                element.style.display = 'block';
            }
            else{
                element.style.display = 'none';
            }
        }
        else
        {
            console.log('Not found')
        }
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row">
                            <div className="col mb-2">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label=""
                                        value={valueStartDate}
                                        onChange={(newValue) => setValueStartDate(newValue)}
                                        sx={
                                            {
                                                backgroundColor: 'white',
                                                width: '100%',
                                                '& .MuiInputBase-root': {
                                                    height: '40px', // ความสูงของ Input Base
                                                    fontSize: 14,
                                                },
                                                '& .MuiPickersPopper-container': {
                                                    maxHeight: '40px', // ความสูงสูงสุดของ Popper
                                                },
                                            }
                                        }
                                        slotProps={{
                                            field: { clearable: true },
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}
                                        format="DD/MM/YYYY"
                                        defaultValue={dayjs()}
                                        maxDate={dayjs()}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col mb-2">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label=""
                                        value={valueEndDate}
                                        onChange={(newValue) => setValueEndDate(newValue)}
                                        sx={
                                            {
                                                backgroundColor: 'white',
                                                width: '100%',
                                                '& .MuiInputBase-root': {
                                                    height: '40px', // ความสูงของ Input Base
                                                    fontSize: 14,
                                                },
                                                '& .MuiPickersPopper-container': {
                                                    maxHeight: '40px', // ความสูงสูงสุดของ Popper
                                                },
                                            }
                                        }
                                        slotProps={{
                                            field: { clearable: true },
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}
                                        format="DD/MM/YYYY"
                                        defaultValue={dayjs()}
                                        minDate={valueStartDate || dayjs()}
                                        maxDate={dayjs()}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-sm-12 col-md-2">
                                <button className="btn btn-primary w-100" onClick={getAllTransactions} disabled={loading}>SEARCH</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row">
                            <div className="col-sm-12 col-xl-4 d-flex" style={{
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                {/* <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="remember-me" onClick={() => setShowOnlyNotMatch(showOnlyNotMatch ? false : true)} />
                                    <label className="form-check-label" htmlFor="remember-me" style={{ color: '#51659e' }}>
                                        Only not match
                                    </label>
                                </div> */}
                            </div>
                            <div className="col-sm-12 col-xl-8" style={{ 
                                display: `flex`,
                                justifyContent: `flex-end`,
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                SHOW:&nbsp;
                                <select id="select2Basic" className="select2 form-select" data-allow-clear="true"
                                    style={{
                                        maxHeight: 40,
                                        maxWidth: 100
                                    }}
                                    defaultValue={`10`}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                        if(!e.target)
                                        {
                                            return;
                                        }

                                        setLimit(parseInt(e.target.value));
                                    }}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                    <option value="70">70</option>
                                    <option value="80">80</option>
                                    <option value="90">90</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="border-top">
                                <tr>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            REF CODE
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            BANK DETAIL
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            AMOUNT
                                        </Typography>
                                    </th>
                                    <th align="center" colSpan={2}>
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            BALANCE
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            STATUS
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            UPDATED TIME
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            CREATED TIME
                                        </Typography>
                                    </th>
                                </tr>
                                <tr>
                                    <th colSpan={3}></th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            BEFORE
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            AFTER
                                        </Typography>
                                    </th>
                                    <th colSpan={3}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    transactions.length > 0 ? transactions.sort((a: payoutTransactionsType, b: payoutTransactionsType) => {
                                        const dateA = new Date(a.createdAt).getTime();
                                        const dateB = new Date(b.createdAt).getTime();
                                        return dateB - dateA;
                                    }).map((transaction: payoutTransactionsType, index: number) => {
                                        return (
                                            <>
                                                <tr key={`row-detail-${index}`} style={
                                                    {
                                                        backgroundColor: transaction.status === 1 ? "rgba(0, 190, 0, .2)" : (
                                                            transaction.status === 0 ? "rgba(190, 190, 0, .2)" : (
                                                                transaction.status === 3 ? "rgba(190, 190, 0, .2)" : "rgba(255, 0, 0, .2)"
                                                            )
                                                        ),
                                                        transition: 'all .3s'
                                                    }
                                                }>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.75rem`}>
                                                            <b>
                                                                {
                                                                    transaction.ref_code
                                                                }
                                                            </b>
                                                            <Divider />
                                                            {
                                                                transaction.customer_ref_code
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.65rem`}>
                                                            {
                                                                bank_data.findIndex(element => element.bank_code == JSON.parse(transaction.bank_customer_data).bank_acc_code) !== -1 ?
                                                                    <Tooltip title={`${bank_data[bank_data.findIndex(element => element.bank_code == JSON.parse(transaction.bank_customer_data).bank_acc_code)].bank_name_en}`}>
                                                                        <img src={bank_data[bank_data.findIndex(element => element.bank_code == JSON.parse(transaction.bank_customer_data).bank_acc_code)].bank_logo} alt={bank_data[bank_data.findIndex(element => element.bank_code == JSON.parse(transaction.bank_customer_data).bank_acc_code)].bank_name_en} style={{
                                                                            maxWidth: '15px',
                                                                            width: '100%'
                                                                        }} />
                                                                    </Tooltip>
                                                                :
                                                                    <>
                                                                        ({JSON.parse(transaction.bank_customer_data).bank_acc_code})
                                                                    </>
                                                            }
                                                            &nbsp;
                                                            {
                                                                JSON.parse(transaction.bank_customer_data).bank_acc_name
                                                            }
                                                        </Typography>
                                                        <Divider />
                                                        <Typography display={'flex'} justifyContent={`center`} alignContent={`center`} alignItems={`center`} align="center" fontSize={`0.70rem`}>
                                                            {
                                                                JSON.parse(transaction.bank_customer_data).bank_acc_number
                                                            }&nbsp;<i className="bx bx-clipboard" style={{
                                                                color: '#1979e6',
                                                                cursor: 'pointer'
                                                            }} onClick={() => copyToClipboard(`${JSON.parse(transaction.bank_customer_data).bank_acc_number}`)}></i>
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            ฿{
                                                                parseFloat(String(`${transaction.amount}`)).toLocaleString('en-US', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            ฿{
                                                                parseFloat(String(`${transaction.agent_balance_before}`)).toLocaleString('en-US', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            ฿{
                                                                parseFloat(String(`${transaction.agent_balance_after}`)).toLocaleString('en-US', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            {
                                                                transaction.status === 1 ? "SUCCESS" : (
                                                                    transaction.status === 0 ? "PENDING" : (
                                                                        transaction.status === 3 ? "PENDING" : "FAIL"
                                                                    )
                                                                )
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            {
                                                                `${String(new Date(String(transaction.updatedAt)).getDate()).padStart(2, '0')}/${String(new Date(String(transaction.updatedAt)).getMonth() + 1).padStart(2, '0')}/${String(new Date(String(transaction.updatedAt)).getFullYear())}`
                                                            }&nbsp;{
                                                                `${String(new Date(String(transaction.updatedAt)).getHours()).padStart(2, '0')}:${String(new Date(String(transaction.updatedAt)).getMinutes()).padStart(2, '0')}:${String(new Date(String(transaction.updatedAt)).getSeconds()).padStart(2, '0')}`
                                                            }
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            {
                                                                `${String(new Date(String(transaction.createdAt)).getDate()).padStart(2, '0')}/${String(new Date(String(transaction.createdAt)).getMonth() + 1).padStart(2, '0')}/${String(new Date(String(transaction.createdAt)).getFullYear())}`
                                                            }&nbsp;{
                                                                `${String(new Date(String(transaction.createdAt)).getHours()).padStart(2, '0')}:${String(new Date(String(transaction.createdAt)).getMinutes()).padStart(2, '0')}:${String(new Date(String(transaction.createdAt)).getSeconds()).padStart(2, '0')}`
                                                            }
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    }) :
                                        <tr>
                                            <td colSpan={10}>
                                                <Typography align="center" fontSize={`0.95rem`}>
                                                    NOT FOUND TRANSACTIONS
                                                </Typography>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default PayoutTransactions;